document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".search-modal__form_custom");
  if (!form) return;

  const input = form.querySelector("input");
  if (!input) return;

  // Select all elements you want to change (except the input)
  const label = form.querySelector(".field__label");
  // Add more selectors as needed

  // Store original colors to revert on blur
  const originalLabelColor = label ? label.style.color : "";
  const originalFormColor = form.style.color;

  input.addEventListener("focus", function () {
    const primary500Color = getComputedStyle(root)
      .getPropertyValue("--color-primary-500")
      .trim();
    if (label) label.style.color = primary500Color;
    form.style.color = primary500Color;
    // Add more as needed
  });

  input.addEventListener("blur", function () {
    if (label) label.style.color = originalLabelColor;
    form.style.color = originalFormColor;
    if (closeButton) closeButton.style.color = originalCloseButtonColor;
    // Add more as needed
  });
});
